import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Quill from 'quill';

import Swal from 'sweetalert2';
import { ListService } from '../list.service';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
// import Quill from 'quill';
import QuillBetterTable from 'quill-better-table';

// تسجيل الموديول
Quill.register(
  {
    'modules/better-table': QuillBetterTable,
  },
  true
);
@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss'],
})
export class CreateComponent implements OnInit, AfterViewInit {
  item: any = '';
  question: any = '';
  quillConfig = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      ['code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ direction: 'rtl' }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [
        {
          size: [
            '10px',
            '12px',
            '14px',
            '16px',
            '18px',
            '24px',
            '32px',
            '48px',
          ],
        },
      ],
      [{ color: [] }, { background: [] }],
      ['link', 'image', 'video'],
      [{ font: [] }],
      [{ align: [] }],
      ['clean'],
      ['table'], // زر الجدول
    ],
    'better-table': {
      operationMenu: {
        items: {
          unmergeCells: {
            text: 'Unmerge cells',
          },
        },
      },
    },
    keyboard: {
      bindings: QuillBetterTable.keyboardBindings,
    },
  };
  htmlText: any = '';
  submitted: boolean = false;
  bolgs_cats: any;
  form: FormGroup;
  public image: File = null;
  public base_64_image: any;
  @ViewChild('editor', { static: false }) editor: any;
  quillEditor: any;

  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private faq: ListService,
    private formbuilder: FormBuilder
  ) {}
  detectImage(event) {
    const file = event.target.files[0];
    this.image = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.base_64_image = reader.result;
    };
  }
  ngAfterViewInit() {
    this.quillEditor = this.editor?.quillEditor;
  }

  ngOnInit(): void {
    this.showAll();
    this.form = this.formbuilder.group({
      title: ['', Validators.required],
      summary: ['', Validators.required],
      category_id: ['', Validators.required],
      meta_title: [null],
      headlines: this.formbuilder.array([this.formbuilder.control('')]),
    });
    const SizeStyle = Quill.import('attributors/style/size');
    SizeStyle.whitelist = [
      '10px',
      '12px',
      '14px',
      '16px',
      '18px',
      '24px',
      '32px',
      '48px',
    ];
    Quill.register(SizeStyle, true);
  }
  /*************  ✨ Windsurf Command ⭐  *************/
  /**
   * Convenience getter for the headlines form array.
   * @returns {FormArray} - The headlines form array.
   */
  /*******  ee68cd41-2fd4-4a37-8c8a-feb397f4394a  *******/
  get headlines() {
    return this.form.get('headlines') as FormArray;
  }
  addHeadline() {
    this.headlines.push(this.formbuilder.control(''));
  }
  onEditorCreated(quill) {
    quill.getModule('better-table');
  }

  removeHeadline(i: number) {
    this.headlines.removeAt(i);
  }
  get f() {
    return this.form.controls;
  }
  showAll() {
    this.spinner.show();
    this.faq.list_cats().subscribe((data: any) => {
      console.log(data);

      this.bolgs_cats = data.data;
      this.form.controls.category_id.setValue(this.bolgs_cats[0].id);
      console.log(data);
      this.spinner.hide();
    });
  }
  add() {
    this.submitted = true;
    if (this.form.invalid || this.htmlText == '' || this.htmlText == null) {
      return;
    }

    const form = {
      ...this.form.value,
      image: this.image,
      content: this.htmlText,
    };
    console.log(form);
    this.spinner.show();
    this.faq.create(form).subscribe((response: any) => {
      console.log(response);
      this.spinner.hide();
      Swal.fire(`نجاح`, `تم أضافة المفال`, `success`);
      this.router.navigate(['/app/blogs/list']);
      // window.location.reload()
    });
  }
  customImageHandler() {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/webp'); // ✅ Only allow .webp
    input.click();

    input.onchange = () => {
      const file = input.files?.[0];
      if (!file) return;

      // ✅ Check file type
      if (file.type !== 'image/webp') {
        alert('Only .webp images are allowed.');
        return;
      }

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64 = reader.result as string;
        const range = this.quillEditor?.getSelection(true);
        this.quillEditor?.insertEmbed(
          range?.index || 0,
          'image',
          base64,
          'user'
        );
      };
    };
  }
}
